import React from "react";

interface UnitToggleProps {
  selectedUnit: "cm" | "inch";
  onUnitChange: (unit: "cm" | "inch") => void;
}

const UnitToggle: React.FC<UnitToggleProps> = ({ selectedUnit, onUnitChange }) => {
  return (
    <div className="flex items-center gap-1 p-1 border rounded-full border-gorgonzola-blue-50 bg-gorgonzola-blue-50/10">
      {(["cm", "inch"] as const).map((unit) => (
        <button
          key={unit}
          onClick={() => onUnitChange(unit)}
          className={`px-2.5 py-1 rounded-full text-xs font-medium transition-all duration-300 border 
            ${selectedUnit === unit ? "bg-gorgonzola-blue-300 text-white" : "border-gorgonzola-blue-50 text-closed-shutter-300 hover:text-closed-shutter-400"}`}
        >
          {unit.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default UnitToggle;
